import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bu: [], // default value
  selectedBu: '',
  selectedCycle: '',
  selectedCycleId: null,
  periodsData: [],
  selectedCycleObj: {}
};

const cycleSlice = createSlice({
  name: 'cycle',
  initialState,
  reducers: {
    setBusinessUnit: (state, action) => {
      localStorage.setItem('bu_name', action.payload);
      state.selectedBu = action.payload; // Set the BU
    },
    setSelectedCycle: (state, action) => {
      localStorage.setItem('cycle_name', action.payload);
      state.selectedCycle = action.payload;
    },
    setSelectedCycleId: (state, action) => {
      localStorage.setItem('cycle_id', action.payload);
      state.selectedCycleId = action.payload;
    },
    setSelectedCycleObj: (state, action) => {
      const { id, cycleName } = action.payload;
      localStorage.setItem('cycle_id', id);
      localStorage.setItem('cycle_name', cycleName);
      state.selectedCycleId = id;
      state.selectedCycle = cycleName;
      state.selectedCycleObj = action.payload;
    },
    setPeriodsData: (state, action) => {
      state.periodsData = action.payload;
    }
  }
});

// Export actions for use in your components
export const {
  setBusinessUnit,
  setSelectedCycle,
  setSelectedCycleId,
  setSelectedCycleObj,
  setPeriodsData
} = cycleSlice.actions;

// Export the reducer to be included in the store
export default cycleSlice.reducer;
